/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { startCase, toLower } from 'lodash';
import { Box, Image, Text, Flex } from 'atoms';
import CloseArrow from 'assets/icons/close-arrow.svg';
import * as SVGICONS from 'utils/svg';
import TotalInvoice from 'assets/icons/total-invoice.svg';
import BillBack from 'assets/icons/bill-back.svg';
import NoBillBack from 'assets/icons/no-bill-back.svg';
import VoucherBack from 'assets/icons/voucher-back.svg';
import NoVoucherBack from 'assets/icons/no-voucher-back.svg';
import Exit from 'assets/exit.svg';
import { theme } from 'styles/theme';
import { Rupee } from 'components';
import { useFindNoOfCheque, useTotalInvoiceAmount } from 'hooks';
import { GetFullName } from 'utils';
import * as Styled from './DetailedModal.style';

const checksegregatorVerified = (value) =>
	[
		'RejectedByCashier',
		'VerifiedByCashier',
		'PartialVerifiedByCashier',
		'VerifiedBySegregator',
	]?.includes(value.invoice_verification_status);
const cashierVerifiedStatus = (value) => value.invoice_verification_status === 'VerifiedByCashier';

export default function DetailedModal({ visible, width = 350, hideDetailedView, showModal }) {
	console.log('DetailedModal');
	const handleClose = () => {
		hideDetailedView();
	};
	const BtnExit = () => {
		showModal();
	};
	const { dashboard, SalesInvoices } = useSelector((state) => state.salesman);
	const { me = {}, selectedSalesMan = {} } = useSelector((state) => state.user);
	const TotalOutstanding = useTotalInvoiceAmount(SalesInvoices);
	const checkCount = useFindNoOfCheque(SalesInvoices);
	const segregatorVerified = SalesInvoices?.every(checksegregatorVerified);
	const cashierVerified = SalesInvoices?.every(cashierVerifiedStatus);
	const cardListData = useMemo(
		() => [
			{
				icon: TotalInvoice,
				label: 'Total Invoice',
				count: Number(SalesInvoices?.length) || 0,
			},
			{
				icon: BillBack,
				label: 'Invoice Returned',
				count: dashboard?.bill_back || 0,
			},
			{
				icon: NoBillBack,
				label: 'Invoice Settled',
				count: dashboard?.no_bill_back || 0,
			},
			{
				icon: VoucherBack,
				label: 'Voucher Returned',
				count: 0,
			},
			{
				icon: NoVoucherBack,
				label: 'Voucher Settled',
				count: 0,
			},
		],
		[SalesInvoices, dashboard]
	);

	return (
		<Modal
			style={{ position: 'relative' }}
			width={width}
			footer={null}
			visible={visible}
			closable={false}
			centered
		>
			<Styled.ModalBackground>
				<Flex mb={3} justifyContent="space-between">
					<Flex alignItems="center">
						<Styled.AvatarImage />
						<Styled.AvatarName>
							<Text id="salesman-name" fontWeight="600">
								{me.type === 'Additional Resource'
									? startCase(toLower(GetFullName.userFullName(selectedSalesMan)))
									: startCase(toLower(GetFullName.userFullName(me)))}
							</Text>
						</Styled.AvatarName>
					</Flex>
					<Flex alignItems="center" onClick={BtnExit}>
						<Styled.AvatarName mr="5px" fontSize="12px" id="salesman-name">
							Logout
						</Styled.AvatarName>
						<Image src={Exit} alt="Exit" />
					</Flex>
				</Flex>
				{cardListData?.map((item) => (
					<Styled.PrimaryList
						key={item.label}
						alignItems="center"
						justifyContent="space-between"
					>
						<Flex alignItems="center">
							<Box style={Styled.PriceIcon} width={24} height={24}>
								<Image src={item.icon} width={10} />
							</Box>
							<Text>{item.label}</Text>
						</Flex>
						<Styled.PrimaryNumber alignItems="center" justifyContent="center">
							{item.count}
						</Styled.PrimaryNumber>
					</Styled.PrimaryList>
				))}
				<Styled.ShowDetailsWrapper onClick={handleClose}>
					<Styled.ShowDetailsArrow
						alignItems="center"
						flexDirection="column"
						justifyContent="center"
					>
						<Image src={CloseArrow} alt="Down Arrow" width={17} />
					</Styled.ShowDetailsArrow>
				</Styled.ShowDetailsWrapper>
				<Flex color={theme.colors.primary} mt={3} justifyContent="space-between">
					<Flex flexDirection="column" justifyContent="end">
						<Text style={Styled.LabelAmount}>
							<Rupee>{TotalOutstanding}</Rupee>
						</Text>
						<Styled.LabelText>Outstanding Carried</Styled.LabelText>
					</Flex>
					<Flex flexDirection="column" justifyContent="end">
						<Text style={Styled.LabelAmount}>
							<Rupee>{dashboard?.total || 0}</Rupee>
						</Text>
						<Styled.LabelText>Total Collection done</Styled.LabelText>
					</Flex>
				</Flex>
				<Styled.CollectionDetailsTitle mt={2}>
					Collection Details
				</Styled.CollectionDetailsTitle>
				<Flex color={theme.colors.primary} mt={1} justifyContent="space-between">
					<Flex flexDirection="column" justifyContent="end">
						<Text style={Styled.LabelAmount}>
							<Rupee>{dashboard?.cash || 0}</Rupee>
						</Text>
						<Styled.LabelText>Cash</Styled.LabelText>
					</Flex>
					<Flex flexDirection="column" justifyContent="end">
						<Text style={Styled.LabelAmount}>
							<Rupee>{dashboard?.upi || 0}</Rupee>
						</Text>
						<Styled.LabelText>UPI</Styled.LabelText>
					</Flex>
					<Flex flexDirection="column" justifyContent="end">
						<Text style={Styled.LabelAmount}>
							<Rupee>{dashboard?.cheque || 0}</Rupee>{' '}
							{checkCount > 0 && `(${checkCount})`}
						</Text>
						<Styled.LabelText>Cheque</Styled.LabelText>
					</Flex>
					<Flex flexDirection="column" justifyContent="end">
						<Text style={Styled.LabelAmount}>
							<Rupee>{dashboard?.neft || 0}</Rupee>
						</Text>
						<Styled.LabelText>NEFT</Styled.LabelText>
					</Flex>
				</Flex>
				<Flex mt={4} mb={3} justifyContent="center" alignItems="center">
					<Flex flexDirection="column" alignItems="center">
						<Styled.IconBgGray
							style={segregatorVerified ? Styled.IconBgGrayActive : {}}
						>
							<SVGICONS.SegregatorVerificationIcons
								width="16px"
								fill={segregatorVerified ? 'white' : '#888888'}
							/>
						</Styled.IconBgGray>
						<Styled.VerificationLabel>Segregator Verification</Styled.VerificationLabel>
					</Flex>
					<Styled.VerificationLine
						style={
							segregatorVerified || cashierVerified
								? Styled.VerificationLabelActive
								: {}
						}
					/>
					<Flex flexDirection="column" alignItems="center">
						<Styled.IconBgGray style={cashierVerified ? Styled.IconBgGrayActive : {}}>
							<SVGICONS.CashierVerificationIcons
								ml="4px"
								width="18px"
								stroke={cashierVerified ? 'white' : '#888888'}
							/>
						</Styled.IconBgGray>
						<Styled.VerificationLabel>Cashier Verification</Styled.VerificationLabel>
					</Flex>
				</Flex>
			</Styled.ModalBackground>
		</Modal>
	);
}
DetailedModal.propTypes = {
	visible: PropTypes.bool,
	width: PropTypes.number,
	hideDetailedView: PropTypes.func,
	showModal: PropTypes.func,
};
